import { DistanceUnit } from '@common/enums/configuration/units';
import { Language } from '../enums/languages';
import OrganizationRole from '../enums/organization-roles';
import UserRole from '../enums/user-roles';
import ListOrganization, { mockListManufacturer } from '../organization/list-organization';
import BaseUser from './base-user';
import INotificationTrigger from './notifications/notification-trigger';
import Acceptance from './agreements/acceptance';
import { OrganizationSubscriptions, RobotSubscriptions } from './current-user';
import { LoginVariant } from './login-details';

interface User extends BaseUser {
  organization: ListOrganization;
}

export default User;

export interface UserData extends BaseUser {
  organizationName: string;
  notifications: INotificationTrigger;
  acceptedAgreements: Acceptance;
  require2fa: boolean;
  twoFactorAuthConfiguration: {
    confirmedAt: string | null;
    failedOtpCount: number;
    lockedUntil: string | null;
    dateCreated: string;
    isConfirmed: boolean;
    isLocked: boolean;
    backupCodes: {
      total: number;
      used: number;
      remaining: number;
    };
  } | null;
  orbitDashboards: {
    id: string;
    name: string;
    description: string;
  };
  orbitDatasets: {
    id: string;
    name: string;
    description: string;
  };
  organizationSubscriptions: OrganizationSubscriptions[];
  robotSubscriptions: RobotSubscriptions[];
  lastLoginVariant: LoginVariant;
  organizationsUserIsContactFor: string[];
  history: {
    historyId: string;
    date: string;
    type: string;
    userId: string | null;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string | null;
    role: UserRole;
    language: Language;
    distanceUnit: DistanceUnit;
    require2fa: boolean;
    lastLoginVariant: LoginVariant;
  };
}

// mock data

export const mockUser = {
  id: '9aca2f49-9bfe-4e3f-a4e0-d45c72a9d085',
  name: 'John Snow',
  dateCreated: '2024-07-26T12:54:13',
  email: 'someEmail@example.ch',
  phoneNumber: null,
  role: UserRole.ADMIN,
  distanceUnit: DistanceUnit.METRIC,
  language: Language.ENGLISH,
  isTwoFactorConfigured: false,
  organization: {
    id: mockListManufacturer.id,
    name: 'Kemaro',
    role: OrganizationRole.MANUFACTURER,
    robotCount: 4,
    parentId: null,
    userCount: 2,
    subOrganizationCount: 1,
  },
} as User;

export const mockUser2 = {
  id: '9aca2f49-9bfe-4e3f-a4e0-d45c72a9d053',
  name: 'Jane Doe',
  dateCreated: '2024-07-26T12:54:13',
  email: 'jane@example.ch',
  phoneNumber: null,
  role: UserRole.MEMBER,
  distanceUnit: DistanceUnit.METRIC,
  language: Language.ENGLISH,
  isTwoFactorConfigured: false,
  organization: {
    id: mockListManufacturer.id,
    name: 'Kemaro',
    role: OrganizationRole.MANUFACTURER,
    robotCount: 4,
    parentId: null,
    userCount: 2,
    subOrganizationCount: 1,
  },
} as User;
